import React, { Component } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import moment from  'moment';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Spinner from '../UI/Spinner/spinner';
import css from './bfm.css';

const LightTooltip = withStyles(theme => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);
class FeedTable extends Component {

    renderAccounttype = (account) => <span className={css.pl10}>{account.includes('XXXX') ? 'Credit Card' : 'Account'}</span>

    renderHeading = () => {
        const { isRAH, isR1 } = this.props;
        return(
        <div className={[css.dFlex, css.headingPadding].join(' ')}>
            <div className={(isRAH || isR1) ? css.w250 : css.w300}>Bank account</div>
            <div className={css.w150}>Created</div>
            <div className={[css.w150, css.textCenter].join(' ')}>Status</div>
            {(isRAH || isR1) && <div className={[css.w150, css.alignRight].join(' ')}>Linked Account</div>}
            <div className={[css.w150, css.alignRight, css.mr45].join(' ')}>Actions</div>
        </div>);
    }

    renderIcons = (row, isRAH, isR1, linkedAccount, isAuthError, unlink) => {
        if (row.status === 'Deleted' || row.isDeleted) {
            if (row.R1BankAccountId) {
                return (<div className={css.icons}><Button onClick={() => unlink(row)} color='primary'>Unlink</Button></div>);
            }
            return
        }

        return ( <div className={css.icons}>
             {row.source === 'Yodlee' && (row.reAuthRequired || isAuthError) &&
                <LightTooltip enterDelay={700} title="Edit Credentials">
                    <span className={[css.tag, css.smallTag, css.redTag].join(' ')} onClick={() => this.props.onIconClicked(row, 'Reauthenticate Feed')}>Re-Auth</span>
                </LightTooltip>}
                
            {((row.status !== 'Active' && row.source === 'Direct' && ![40].includes(row.bankId)) || [46, 47].includes(row.bankId)) 
            ? <LightTooltip enterDelay={700} title="Download Feed Form">
                <i onClick={() => this.props.onIconClicked(row, 'Download Feed Form')} className="fas fa-download"></i>
            </LightTooltip> : null}

            {((row.status !== 'Active' && row.source === 'Direct' && ![1, 31, 40].includes(row.bankId)) || [46, 47].includes(row.bankId)) 
            ? <LightTooltip enterDelay={700} title="Upload Feed Form">
                <i onClick={() => this.props.onIconClicked(row, 'Upload Feed Form')} className="fas fa-upload"></i>
            </LightTooltip> : null}

            { (isRAH || isR1) && 
                ((Boolean(linkedAccount))
                    ? <LightTooltip enterDelay={700} title="Feed mapped">
                        <span><i onClick={() => this.props.onIconClicked(row, 'Feed Mapping')} className="fas fa-link"></i></span>
                    </LightTooltip>
                    : <LightTooltip className={css.pointer} enterDelay={700} title="Feed not mapped to bank account">
                        <span className={css.orange}><i onClick={() => this.props.onIconClicked(row, 'Feed Mapping')} className="fas fa-link"></i></span>
                    </LightTooltip>)}

            <LightTooltip enterDelay={700} title="View feed details">
                <i onClick={() => this.props.onIconClicked(row, 'Feed Details')} className="fas fa-file-alt"></i>
            </LightTooltip>

            <LightTooltip enterDelay={700} title="Delete this feed">
                <i onClick={() => this.props.onIconClicked(row, 'Delete Feed')} className="fas fa-trash-alt"></i>
            </LightTooltip>
        </div>);
    }

    renderRow = (row) => {
        const { isRAH, isR1, bankAccounts, unlink } = this.props;
        const tagCss = [css.tag];

        if (row.status === 'Active' && !row.isDeleted) {
            tagCss.push(css.greenTag);
        } else if (row.status === 'Form Received' || row.status === 'Form with Bank') {
            tagCss.push(css.orangeTag);
        } else {
            tagCss.push(css.redTag);
        }

        const linkedAccount = bankAccounts && isRAH ? bankAccounts.find(account => row.RAHBankAccountId === account.RAHBankAccountId)
                                                    : bankAccounts.find(account => row.R1BankAccountId === account.R1BankAccountID);

        const linkedAccountName = linkedAccount ? linkedAccount.AccountName : 'Link';
        const isAuthError = row.status === "Yodlee Error" || row.status === "Authentication Required" || row.status === "Authentication Failed Due To MFA";

        return (
        <div className={[css.dFlex, css.alignCenter, css.feedRow].join(' ')}>
            <div className={[((isRAH || isR1) ? css.w215 : css.w300), css.pl10].join(' ')}>
                <div className={css.pb6}>{row.accountName}</div>
                <div className={[css.fontSmall, css.fontLight].join(' ')}>
                    <span>{row.bank}:</span>
                    {(Boolean(row.bsb && row.bsb.length)) && 
                    isNaN(row.accountNumber) ? this.renderAccounttype(row.accountName) : 
                    <React.Fragment>
                        <span className={css.pl10}>{row.bsb && `${row.bsb.substring(0, 3)}-${row.bsb.substring(3, 6)}`}</span>
                        <span className={css.pl10}>{row.accountNumber}</span>
                    </React.Fragment>}
                </div>
            </div>
            <div className={(isRAH || isR1) ? css.w120 : css.w150}>{moment(row.feedCreated).subtract(moment().isDST() ? 10 : 11, 'hours').calendar(null, { sameDay: '[Today]', lastDay: '[Yesterday]', lastWeek: '[Last] dddd', sameElse: 'DD MMM YY' })}</div>
            <div className={css.w150}>
                <div onClick={() => this.props.onIconClicked(row, 'Feed Details')} className={tagCss.join(' ')}>{row.isDeleted ? 'Deleted' : row.status}</div>
            </div>
            {(isRAH || isR1) && <div className={[css.w150, css.textCenter].join(' ')}>
                    <Button onClick={() => this.props.onIconClicked(row, 'Feed Mapping')}>
                        <LightTooltip enterDelay={700} title={linkedAccountName}>
                            <span className={css.overflow}>{linkedAccountName}</span>
                        </LightTooltip>
                    </Button>
            </div> }
           {this.renderIcons(row, isRAH, isR1, linkedAccount, isAuthError, unlink)}
        </div>
    )};

    render() {
        if (!this.props.feeds) return <Spinner small />
        return (
            <ul className={css.feedList}>
              <li>{this.renderHeading()}</li>
              {(this.props.feeds.length === 0)
                ? <li className={css.noData}>There are no bank feeds</li>
                : this.props.feeds.map((feed, index) => <li key={index}>{this.renderRow(feed)}</li>)}  
            </ul>
        );
    }
}

export default FeedTable;


// WEBPACK FOOTER //
// ./src/components/FeedManagment/FeedTable.js